import { render } from "./ItemAccordionRequete.vue?vue&type=template&id=1df98a63"
import script from "./ItemAccordionRequete.vue?vue&type=script&lang=js"
export * from "./ItemAccordionRequete.vue?vue&type=script&lang=js"

import "./ItemAccordionRequete.vue?vue&type=style&index=0&id=1df98a63&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__